import * as dataNormalizers from "./dataNormalizers";
import * as listHeads from "./listHeads";
import * as filterBuilders from "./filterBuilders";

export const forms = [
    "Immigration",
    "Taxes",
    "Crime",
    "Injury",
    "Family"
];

export function getForm(formName) {
    return require(`./${formName}`).default;
}

export function getDataNormalizer(formName) {
    return dataNormalizers[formName] || ((d) => d);
}

export function getListHead(formName) {
    return listHeads[formName];
}

export function getFiltersBuilder(formName) {
  return filterBuilders[formName];
}